import {
  LocationMatchesForMassBookingState,
  LocationMatchesForMassBookingActionTypes,
  LOCATION_MATCHES_FOR_MASS_BOOKING_REQUEST,
  LOCATION_MATCHES_FOR_MASS_BOOKING_SUCCESS,
  LOCATION_MATCHES_FOR_MASS_BOOKING_FAILURE
} from 'store/reducers/lodgingOption/location-matches-for-mass-booking/types';

const defaultState: LocationMatchesForMassBookingState = {
  isLoading: false,
  errorMessage: ""
};

export default function locationMatchesForMassBooking(state = defaultState, action: LocationMatchesForMassBookingActionTypes): LocationMatchesForMassBookingState {
  switch (action.type) {
    case LOCATION_MATCHES_FOR_MASS_BOOKING_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case LOCATION_MATCHES_FOR_MASS_BOOKING_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case LOCATION_MATCHES_FOR_MASS_BOOKING_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};